import HoverFix from './HoverFix';

export default {
  __init__: [
    'hoverFix'
  ],
  hoverFix: [ 'type', HoverFix ],
};